import React from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'

import { CompanyLogo } from 'core/components'
import Icon from 'core/components/Icon'
import { useRect } from 'core/hooks'
import variables from 'core/styles/variables'
// this should be portal-ing
// so it doesn't pick up styles from it's react parent

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  padding: 120px 16px;
  margin: 0 !important;
  overflow-y: auto;
  background-color: rgb(0 0 0 / 50%);
`

const Card = styled.div`
  max-width: 480px;
  margin: auto;
  overflow: hidden;
  background: ${variables.colorWhite};
  border-radius: 6px;
  box-shadow: ${variables.peachyShadow};
`

const CardContents = styled.div`
  padding: ${(p) => (p.isCompact ? '16px' : '28px 40px')};
`

const LogoArea = styled.div`
  text-align: center;
`

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  display: inline-block;
  padding: 4px 12px;
  color: white;
  cursor: pointer;
  background-color: transparent;
  border: none;
`

const ErrorFooter = styled.div`
  padding: 8px 24px;
  font-size: 14px;
  color: ${variables.colorBlack80};
  background-color: ${variables.colorRedLighten};
`

const OneTimeCodeOverlay = ({ children, errorMessage, onClose }) => {
  const [{ width }, ref] = useRect()

  const isCompact = width < 420

  return (
    <Wrapper>
      <Card ref={ref} isCompact={isCompact}>
        <CardContents>
          <LogoArea>
            <CompanyLogo type='appLargeCentered' />
          </LogoArea>

          <Contents>{children}</Contents>
        </CardContents>

        {errorMessage && <ErrorFooter>{errorMessage}</ErrorFooter>}
      </Card>
      <CloseButton onClick={onClose}>
        <Icon name='clear' inline />
      </CloseButton>
    </Wrapper>
  )
}

OneTimeCodeOverlay.propTypes = {
  errorMessage: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
}

export default OneTimeCodeOverlay
